import {Component, HostListener, OnInit} from '@angular/core';
import {NavigationEnd, Router, Scroll} from "@angular/router";

@Component({
  selector: 'app-faqs',
  templateUrl: './faqs.component.html',
  styleUrls: ['./faqs.component.scss']
})
export class FaqsComponent implements OnInit {

  faqsList = [
    {
      mainCategory: $localize`:@@platformOverview:Platform Overview`,
      subList: [
        {
          "question": $localize`:@@faqQ1:What is Akl Bayti?`,
          "answer": $localize`:@@faqQ1Answer:Akl Bayti is a marketplace for homemade food.`
        },
        {
          "question": $localize`:@@faqQ2:How does Akl Bayti work?`,
          "answer": $localize`:@@faqQ2Answer:Merchants can create pages to showcase their work. Customers can browse or search for merchants and their products but must contact the merchant manually through the provided contact information.`
        },
        {
          "question": $localize`:@@faqQ3:Who can use Akl Bayti?`,
          "answer": $localize`:@@faqQ3Answer:Anyone can use Akl Bayti.`
        },
        {
          "question": $localize`:@@faqQ4:Is there a mobile app for Akl Bayti?`,
          "answer": $localize`:@@faqQ4Answer:Currently, Akl Bayti is only available via the website, but a mobile app is planned for the future.`
        }
      ]
    },
    {
      "mainCategory": $localize`:@@userTypes:User Types`,
      subList: [
        {
          "question": $localize`:@@faqQ5:Who are the primary users of Akl Bayti?`,
          "answer": $localize`:@@faqQ5Answer:The platform is ideal for home chefs, local farms doing online business, and catering companies.`
        },
        {
          "question": $localize`:@@faqQ6:What are the benefits for home chefs using Akl Bayti?`,
          "answer": $localize`:@@faqQ6Answer:Home chefs can showcase their work among similar chefs, providing customers a clutter-free experience optimized for homemade food.`
        },
        {
          "question": $localize`:@@faqQ7:What are the benefits for customers using Akl Bayti?`,
          "answer": $localize`:@@faqQ7Answer:Customers can find homemade food in one place and view ratings and reviews from other customers.`
        },
      ]
    },
    {
      "mainCategory": $localize`:@@registrationAndOnboarding:Registration and Onboarding`,
      subList: [
        {
          "question": $localize`:@@faqQ8:How can home chefs register on Akl Bayti?`,
          "answer": $localize`:@@faqQ8Answer:Home chefs can register by visiting the merchants’ registration page at https://test-www.aklbayti.com/merchants/signup and filling out the forms.`
        },
        {
          "question": $localize`:@@faqQ9:What is the process for customers to sign up?`,
          "answer": $localize`:@@faqQ9Answer:Customers can sign up by visiting the home page and clicking the sign-up button.`
        },
        {
          "question": $localize`:@@faqQ10:Is there a fee for home chefs to join Akl Bayti?`,
          "answer": $localize`:@@faqQ10Answer:No, joining Akl Bayti is currently free for home chefs.`
        },
      ]
    },
    {
      "mainCategory": $localize`:@@productListing:Product Listings`,
      subList: [
        {
          "question": $localize`:@@faqQ11:How can home chefs list their products?`,
          "answer": $localize`:@@faqQ11Answer:Home chefs can log in to their accounts and manage their information, including addresses, products, gallery, and contact information.`
        },
        {
          "question": $localize`:@@faqQ12:What kind of products can be listed?`,
          "answer": $localize`:@@faqQ12Answer:All the food that home chefs make and sell can be listed.`
        },
        {
          "question": $localize`:@@faqQ13:Are there any guidelines or restrictions for product listings?`,
          "answer": $localize`:@@faqQ13Answer:There are no specific guidelines or restrictions at the moment, but the products must be food.`
        },
        {
          "question": $localize`:@@faqQ14:How can home chefs update their product listings?`,
          "answer": $localize`:@@faqQ14Answer:Home chefs can log in to their account and update their product listings from their dashboard.`
        },
        {
          "question": $localize`:@@faqQ15:Is there a limit to how many products a home chef can list?`,
          "answer": $localize`:@@faqQ15Answer:There is no limit to the number of products a home chef can list.`
        },
      ]
    },
    {
      "mainCategory": $localize`:@@priceAndPayments:Pricing and Payments`,
      subList: [
        {
          "question": $localize`:@@faqQ16:How is pricing determined?`,
          "answer": $localize`:@@faqQ16Answer:The service is currently free.`
        },
        {
          "question": $localize`:@@faqQ17:What payment methods are accepted?`,
          "answer": $localize`:@@faqQ17Answer:N/A, as transactions are handled offline.`
        },
        {
          "question": $localize`:@@faqQ18:How and when do home chefs get paid?`,
          "answer": $localize`:@@faqQ18Answer:N/A, as transactions are handled offline between customers and merchants.`
        },
      ]
    },
    {
      "mainCategory": $localize`:@@orderAndManagement:Order Management`,
      subList: [
        {
          "question": $localize`:@@faqQ19:How are orders placed?`,
          "answer": $localize`:@@faqQ19Answer:Orders are placed offline between the customer and the merchant.`
        },
        {
          "question": $localize`:@@faqQ20:How can home chefs manage their orders?`,
          "answer": $localize`:@@faqQ20Answer:N/A at the moment.`
        },
        {
          "question": $localize`:@@faqQ21:What is the process for order delivery or pickup?`,
          "answer": $localize`:@@faqQ21Answer:N/A at the moment.`
        },
        {
          "question": $localize`:@@faqQ22:Can customers schedule orders for a future date?`,
          "answer": $localize`:@@faqQ22Answer:Scheduling orders for future dates is handled directly between the customer and the merchant.`
        },
      ]
    },
    {
      "mainCategory": $localize`:@@customerSupport:Customer Support`,
      subList: [
        {
          "question": $localize`:@@faqQ23:What should users do if they encounter an issue?`,
          "answer": $localize`:@@faqQ23Answer:Users should contact the merchant directly.`
        },
        {
          "question": $localize`:@@faqQ24:Is there a customer support team available?`,
          "answer": $localize`:@@faqQ24Answer:There isn’t a customer support team at the moment, but users can chat with the AI chatbot on the website anytime.`
        },
        {
          "question": $localize`:@@faqQ25:How can users contact customer support?`,
          "answer": $localize`:@@faqQ25Answer:Users can chat with the AI chatbot on the website.`
        }
      ]
    },
    {
      "mainCategory": $localize`:@@reviewsAndRating:Reviews and Ratings`,
      subList: [
        {
          "question": $localize`:@@faqQ26:Can customers leave reviews?`,
          "answer": $localize`:@@faqQ26Answer:Yes, customers can create accounts and leave reviews.`
        },
        {
          "question": $localize`:@@faqQ27:How do ratings work?`,
          "answer": $localize`:@@faqQ27Answer:Customers can leave reviews and ratings for merchants. Akl Bayti moderators review the comments and approve or reject them based on internal guidelines.`
        },
        {
          "question": $localize`:@@faqQ28:Can home chefs respond to reviews?`,
          "answer": $localize`:@@faqQ28Answer:Not at this moment, but this feature will be available soon.`
        },
        {
          "question": $localize`:@@faqQ29:Can home chefs remove negative reviews?`,
          "answer": $localize`:@@faqQ29Answer:Home chefs cannot remove negative reviews, but they can report them for review by Akl Bayti moderators.`
        },
        {
          "question": $localize`:@@faqQ30:How can customers rate the food they purchase?`,
          "answer": $localize`:@@faqQ30Answer:Customers can leave a rating out of 5 stars and write a review after purchasing food.`
        }
      ]
    },
    {
      "mainCategory": $localize`:@@safetyAndQuality:Safety and Quality`,
      subList: [
        {
          "question": $localize`:@@faqQ31:How does Akl Bayti ensure food safety and quality?`,
          "answer": $localize`:@@faqQ31Answer:Food safety and quality are the responsibility of the merchant. Merchants must ensure their food is clean and of high quality to maintain good ratings and reviews.`
        },
        {
          "question": $localize`:@@faqQ32:Are there any certifications or standards required for home chefs?`,
          "answer": $localize`:@@faqQ32Answer:No, there are no certifications or standards required for home chefs at the moment.`
        },
        {
          "question": $localize`:@@faqQ33:What happens if a customer receives food that doesn’t match the description?`,
          "answer": $localize`:@@faqQ33Answer:The customer should contact the merchant directly to resolve any issues.`
        }
      ]
    },
    {
      "mainCategory": $localize`:@@marketingAndPromotions:Marketing and Promotions`,
      subList: [
        {
          "question": $localize`:@@faqQ34:Are there any promotional opportunities for home chefs?`,
          "answer": $localize`:@@faqQ34Answer:Being part of the platform itself is a promotional opportunity. More options will be available later.`
        },
        {
          "question": $localize`:@@faqQ35:How can home chefs increase their visibility on the platform?`,
          "answer": $localize`:@@faqQ35Answer:This feature is currently unavailable but will be revealed and communicated soon.`
        },
        {
          "question": $localize`:@@faqQ36:Can home chefs offer discounts or promotions?`,
          "answer": $localize`:@@faqQ36Answer:Home chefs can manually offer discounts or promotions and communicate them through their profile.`
        },
        {
          "question": $localize`:@@faqQ37:Is there a loyalty program for frequent customers?`,
          "answer": $localize`:@@faqQ37Answer:A loyalty program is in the planning stages and will be introduced soon.`
        },
        {
          "question": $localize`:@@faqQ38:How can customers share their favorite home chefs or products?`,
          "answer": $localize`:@@faqQ38Answer:Customers can share links to their favorite home chefs or products on social media.`
        }
      ]
    },
    {
      "mainCategory": $localize`:@@policiesAndTerms:Policies and Terms`,
      subList: [
        {
          "question": $localize`:@@faqQ39:What are the cancellation and refund policies?`,
          "answer": $localize`:@@faqQ39Answer:There are no payments processed on the platform, so no refunds are applicable.`
        },
        {
          "question": $localize`:@@faqQ40:What are the terms and conditions for using Akl Bayti?`,
          "answer": $localize`:@@faqQ40Answer:Users can check the terms and conditions on the website.`
        },
        {
          "question": $localize`:@@faqQ41:Are there any privacy policies in place?`,
          "answer": $localize`:@@faqQ41Answer:Yes, the privacy policies are available on the website.`
        }
      ]
    },
    {
      "mainCategory": $localize`:@@technicalIssues:Technical Issues`,
      subList: [
        {
          "question": $localize`:@@faqQ42:What should users do if they encounter technical issues?`,
          "answer": $localize`:@@faqQ42Answer:Users should contact Akl Bayti at hello@aklbayti.com.`
        },
        {
          "question": $localize`:@@faqQ43:Are there any troubleshooting guides available?`,
          "answer": $localize`:@@faqQ43Answer:No, there are no troubleshooting guides available at the moment.`
        }
      ]
    },
    {
      "mainCategory": $localize`:@@futureDevelopments:Future Developments`,
      subList: [
        {
          "question": $localize`:@@faqQ44:Are there any upcoming features or expansions planned?`,
          "answer": $localize`:@@faqQ44Answer:No specific details are available about upcoming features or expansions at the moment.`
        },
        {
          "question": $localize`:@@faqQ45:How can users stay updated with the latest news and updates?`,
          "answer": $localize`:@@faqQ45Answer:Users can subscribe to the newsletter to stay updated with the latest news and updates.`
        },
        {
          "question": $localize`:@@faqQ46:Are there any community features on Akl Bayti?`,
          "answer": $localize`:@@faqQ46Answer:Community features like forums or groups are planned for the future to enhance interaction.`
        },
        {
          "question": $localize`:@@faqQ47:Can home chefs see analytics for their profile?`,
          "answer": $localize`:@@faqQ47Answer:Analytics features are planned for the future to help home chefs track their performance.`
        },
        {
          "question": $localize`:@@faqQ48:Can customers follow their favorite home chefs?`,
          "answer": $localize`:@@faqQ48Answer:Following favorite home chefs is a feature planned for the future.`
        },
        {
          "question": $localize`:@@faqQ49:Are there any partnerships with local businesses?`,
          "answer": $localize`:@@faqQ49Answer:Akl Bayti is exploring partnerships with local businesses to enhance the platform’s offerings.`
        }
      ]
    }, {
      "mainCategory": $localize`:@@miscellaneous:Miscellaneous`,
      subList: [
        {
          "question": $localize`:@@faqQ50:What types of homemade food can be found on Akl Bayti?`,
          "answer": $localize`:@@faqQ50Answer:A wide variety of homemade foods including baked goods, savory dishes, beverages, and more can be found.`
        },
        {
          "question": $localize`:@@faqQ51:Can customers filter their searches by specific food types?`,
          "answer": $localize`:@@faqQ51Answer:Yes, customers can filter their searches by specific food types to find exactly what they’re looking for.`
        },
        {
          "question": $localize`:@@faqQ52:Can home chefs showcase their cooking process on their profiles?`,
          "answer": $localize`:@@faqQ52Answer:Yes, home chefs can upload photos and videos of their cooking process in their gallery.`
        },
        {
          "question": $localize`:@@faqQ53:Can customers see the location of the home chef?`,
          "answer": $localize`:@@faqQ53Answer:Yes, customers can see the general location of the home chef to help with order planning.`
        },
        {
          "question": $localize`:@@faqQ54:How does Akl Bayti handle disputes between customers and merchants?`,
          "answer": $localize`:@@faqQ54Answer:Disputes are handled directly between customers and merchants. Akl Bayti does not mediate at this time.`
        },
        {
          "question": $localize`:@@faqQ55:What languages is Akl Bayti available in?`,
          "answer": $localize`:@@faqQ55Answer:Currently, Akl Bayti is available in English and Arabic.`
        },
        {
          "question": $localize`:@@faqQ56:How are home chefs’ profiles verified?`,
          "answer": $localize`:@@faqQ56Answer:Currently, there is no formal verification process, but this may be introduced in the future.`
        },
        {
          "question": $localize`:@@faqQ57:Is there a newsletter for home chefs?`,
          "answer": $localize`:@@faqQ57Answer:Yes, home chefs can subscribe to a newsletter for updates and tips.`
        },
        {
          "question": $localize`:@@faqQ58:How can customers provide feedback on the platform?`,
          "answer": $localize`:@@faqQ58Answer:Customers can provide feedback by contacting Akl Bayti at hello@aklbayti.com.`
        }
      ]
    },
  ]

  selectedFaqIndex = 0
  isMobileView: boolean = false

  constructor(
    private router: Router,
  ) {

  }

  ngOnInit(): void {
    if (window.innerWidth < 768) {
      this.isMobileView = true
    }
    this.router.events.pipe().subscribe({
      next: (event) => {
        if (event instanceof Scroll) {
          if (event.routerEvent instanceof NavigationEnd) {
            let activeFaq = event.routerEvent.url.substring(event.routerEvent.url.lastIndexOf("/") + 1)
            if (activeFaq === "") {
              this.selectedFaqIndex = 0
            } else if (activeFaq === "users") {
              this.selectedFaqIndex = 1
            } else if (activeFaq === "registration-and-onboarding") {
              this.selectedFaqIndex = 2
            } else if (activeFaq === "product-listings") {
              this.selectedFaqIndex = 3
            } else if (activeFaq === "pricing-and-payments") {
              this.selectedFaqIndex = 4
            } else if (activeFaq === "order-management") {
              this.selectedFaqIndex = 5
            } else if (activeFaq === "customer-support") {
              this.selectedFaqIndex = 6
            } else if (activeFaq === "reviews-and-ratings") {
              this.selectedFaqIndex = 7
            } else if (activeFaq === "safety-and-quality") {
              this.selectedFaqIndex = 8
            } else if (activeFaq === "marketing-and-promotions") {
              this.selectedFaqIndex = 9
            } else if (activeFaq === "policies-and-terms") {
              this.selectedFaqIndex = 10
            } else if (activeFaq === "technical-issues") {
              this.selectedFaqIndex = 11
            } else if (activeFaq === "future-developments") {
              this.selectedFaqIndex = 12
            } else if (activeFaq === "miscellaneous") {
              this.selectedFaqIndex = 13
            }
          }
        }
      }
    })
  }

  loadQuestions(index: number) {
    this.selectedFaqIndex = index
    let route = ""
    if (this.selectedFaqIndex === 0) {
      route = ""
    } else if (this.selectedFaqIndex === 1) {
      route = "users"
    } else if (this.selectedFaqIndex === 2) {
      route = "registration-and-onboarding"
    } else if (this.selectedFaqIndex === 3) {
      route = "product-listings"
    } else if (this.selectedFaqIndex === 4) {
      route = "pricing-and-payments"
    } else if (this.selectedFaqIndex === 5) {
      route = "order-management"
    } else if (this.selectedFaqIndex === 6) {
      route = "customer-support"
    } else if (this.selectedFaqIndex === 7) {
      route = "reviews-and-ratings"
    } else if (this.selectedFaqIndex === 8) {
      route = "safety-and-quality"
    } else if (this.selectedFaqIndex === 9) {
      route = "marketing-and-promotions"
    } else if (this.selectedFaqIndex === 10) {
      route = "policies-and-terms"
    } else if (this.selectedFaqIndex === 11) {
      route = "technical-issues"
    } else if (this.selectedFaqIndex === 12) {
      route = "future-developments"
    } else if (this.selectedFaqIndex === 13) {
      route = "miscellaneous"
    }
    this.router.navigate(['faqs/' + route]).then()
  }

  @HostListener('window:resize', ['$event'])
  onResize(_: any) {
    this.isMobileView = window.innerWidth < 768 && window.innerHeight < 1020;
  }

}
